export async function getChallenge() {
    let loginpage = await fetch("/login");
    if (!loginpage.ok) throw new Error(loginpage.status);

    let dom = (new DOMParser()).parseFromString(loginpage.body);
    return dom.getElementById("challenge").value
}

export function postResponse(signature) {
    return fetch("/auth", {
                                method: 'POST',
                                body: `signed_challenge=${signature}`,
                                headers: new Headers({'Content-Type': 'text/plain'})
                            });
}